import Vue from 'vue';
import { mapGetters } from 'vuex';
import vuescroll from 'vuescroll';
import _ from 'lodash';
const handleChangeScrollByProperty = (vm) => {
    const value = vm.scrollBy;
    if (value.dx || value.dy) {
        vm.$refs.scrollComponent.scrollBy(value);
        vm.$emit('onManualMove');
        setTimeout(() => {
            debouncedHandleChangeScrollByProperty(vm);
        }, 50);
    }
};
const debouncedHandleChangeScrollByProperty = _.debounce(handleChangeScrollByProperty, 100);
export default Vue.extend({
    name: 'scrollComponent',
    props: {
        isMain: {
            type: Boolean
        },
        onlyHorizontal: {
            type: Boolean
        },
        onlyVertical: {
            type: Boolean
        },
        isDisabled: {
            type: Boolean,
            default: false
        },
        y: {
            type: Boolean
        },
        x: {
            type: Boolean
        },
        scrollBy: {
            type: Object,
            default: () => ({
                dx: 0,
                dy: 0
            })
        },
        scrollTo: {
            type: Object,
            default: () => ({
                x: 0,
                y: 0
            })
        }
    },
    data: () => ({
        shiftKey: false,
        ops: {
            vuescroll: {
                mode: 'native',
                sizeStrategy: 'percent',
                detectResize: true,
                wheelScrollDuration: 400,
                checkShifKey: true,
                zooming: false
            },
            scrollPanel: {
                speed: 100,
                easing: 'easeOutQuad',
                initialScrollY: 0,
                initialScrollX: 0,
                scrollingX: false,
                scrollingY: false
            },
            bar: {
                showDelay: 500,
                onlyShowBarOnScroll: false,
                keepShow: true,
                background: 'rgba(255, 255, 255, 0.545)',
                opacity: 1,
                hoverStyle: false,
                specifyBorderRadius: false,
                minSize: 0.2,
                size: '2px'
            },
            rail: {
                background: '#2C2C2C',
                opacity: 1,
                size: '12px',
                gutterOfEnds: null,
                gutterOfSide: '2px',
                keepShow: false
            },
            scrollButton: {
                enable: true,
                background: 'rgba(255, 255, 255, 0.5442)',
                opacity: 1,
                step: 50,
                mousedownStep: 30
            }
        },
        process: 0,
        scrollState: {
            top: 0,
            left: 0
        },
        counter: 0,
        removeScrollTimeout: null,
        isInited: false
    }),
    computed: Object.assign({}, mapGetters('popupModule', ['getPopupIsOpened'])),
    watch: {
        scrollBy: {
            handler() {
                const vm = this;
                debouncedHandleChangeScrollByProperty(vm);
            },
            deep: true
        },
        scrollTo: {
            handler(newState) {
                this.$refs.scrollComponent.scrollTo(newState, 400, 'linear');
            },
            deep: true
        },
        process(v) {
            this.$emit('changePosition', v);
        },
        getPopupIsOpened(v) {
            if (this.isMain) {
                const { scrollComponent } = this.$refs;
                this.ops.scrollPanel.scrollingY = !v;
                scrollComponent.refresh();
            }
        }
    },
    methods: {
        handleResize(eventY, eventX) {
            this.scrollState.top = eventY.scrollTop;
            this.scrollState.left = eventX.scrollLeft;
        },
        handleScroll(eventY, eventX) {
            this.scrollState.top = eventY.scrollTop;
            this.scrollState.left = eventX.scrollLeft;
            const vm = this;
            if (vm.isMain) {
                if (eventY.scrollTop > 0) {
                    document.body.classList.add('scrolled');
                }
                else
                    document.body.classList.remove('scrolled');
            }
            this.process = eventY.process;
            const { scrollComponent } = this.$refs;
            scrollComponent.$el.classList.add('scrolling');
            if (this.removeScrollTimeout === null) {
                this.removeScrollTimeout = setTimeout(() => {
                    scrollComponent.$el.classList.remove('scrolling');
                    this.removeScrollTimeout = null;
                }, 1000);
            }
            if (this.process > 0 && this.process < 1)
                this.counter = 0;
        },
        onMouseWheel(event) {
            const vm = this;
            const { scrollComponent } = this.$refs;
            if (!this.onlyHorizontal) {
                const panelEl = scrollComponent.$el.querySelector('.__panel');
                const canPanelScroll = panelEl
                    ? panelEl.scrollHeight > panelEl.clientHeight + 1
                    : false;
                if (vm.isMain && !canPanelScroll) {
                    event.preventDefault();
                    const delta = event.deltaMode === 1 ? event.deltaY * 16 : event.deltaY;
                    window.scrollBy(0, delta);
                    if (document.documentElement.scrollTop > 0) {
                        document.body.classList.add('scrolled');
                    }
                    else {
                        document.body.classList.remove('scrolled');
                    }
                    return;
                }
                if (vm.counter < 2)
                    event.preventDefault();
                vm.counter++;
            }
            else {
                event.preventDefault();
                event.stopPropagation();
                scrollComponent.scrollBy({ dx: event.deltaY });
            }
        }
    },
    created() {
        const vm = this;
        const computeX = () => {
            if (vm.onlyVertical)
                return false;
            if (vm.onlyHorizontal)
                return true;
            return vm.x;
        };
        const computeY = () => {
            if (vm.onlyHorizontal)
                return false;
            if (vm.onlyVertical)
                return true;
            return vm.y;
        };
        vm.ops.bar.disable = vm.isDisabled;
        if (!vm.isDisabled) {
            vm.ops.scrollPanel.scrollingX = computeX();
            vm.ops.scrollPanel.scrollingY = computeY();
        }
    },
    mounted() {
        const vm = this;
        const { scrollComponent } = vm.$refs;
        window.addEventListener('resize', () => {
            scrollComponent.refresh();
        });
        if (!scrollComponent.scrollYEnable)
            this.$emit('changePosition', 1);
        if (vm.isMain) {
            let touchStartY = 0;
            const el = scrollComponent.$el;
            el.addEventListener('touchstart', (e) => {
                touchStartY = e.touches[0].clientY;
            }, { passive: true });
            el.addEventListener('touchmove', (e) => {
                const panelEl = el.querySelector('.__panel');
                if (panelEl && panelEl.scrollHeight > panelEl.clientHeight + 1)
                    return;
                // Let nested scroll panels handle their own scroll
                let node = e.target;
                while (node && node !== el) {
                    if (node.classList && node.classList.contains('__panel') && node !== panelEl) {
                        if (node.scrollHeight > node.clientHeight + 1)
                            return;
                    }
                    node = node.parentElement;
                }
                e.preventDefault();
                const delta = touchStartY - e.touches[0].clientY;
                window.scrollBy(0, delta);
                touchStartY = e.touches[0].clientY;
                document.body.classList.toggle('scrolled', document.documentElement.scrollTop > 0);
            }, { passive: false });
        }
    },
    components: {
        vueScroll: vuescroll
    }
});
